
import { Container } from "../../../components/Container"
import { Section } from "../../../components/Section"
import { Steps } from "../../../components/Steps"
import { StepsContent } from "../../../context/StepsContext"
import { InsuranceInfo } from "../../../containers/InsuranceInfo"
import { Step2Form } from '../../../containers/chaloupka/Step2Form'
import { useInsuranceParamsContext } from "../../../layouts/Wizard"
import { Loading } from "../../../components/Loading"
import WizardForbiddenMessage from "../../../components/WizardForbiddenMessage"
import { WithAuth } from "../../../containers/hoc/WithAuth"

const _Step2 = () => {
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) && !isLoadingData &&
          <StepsContent sx={{ minH: '3000px' }} step={2}>
            <Steps icon="house" />

            <InsuranceInfo />

            <Step2Form />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step2 = WithAuth(_Step2)